export default __webpack_public_path__ + "static/media/team-member-bg.4c06bb5e.svg";